export default "__VITE_ASSET__Dw8xQ7iL__"